import React from 'react';
import PropTypes from 'prop-types';

class Redirect extends React.Component {
  static propTypes = {
    url: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
  }

  componentDidMount = () => {
    window.location.href = this.props.url;
  }

  render() {
    return (
      <React.Fragment>
        {this.props.text}
      </React.Fragment>
    );
  }
}

export default Redirect;
